import { useMutation, useQueryClient } from '@tanstack/react-query';
import { meetingTypeApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateMeetingType(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) =>
      meetingTypeApiClient.createMeetingType(jobId, { name }),
    meta: {
      successMessageFn: (data: unknown) =>
        `"${(data as { name: string }).name}" Created`,
    },
    onSettled: () => invalidateFor('meetingType.create', qc, { jobId }),
  });
}
